import { faPlus, faShieldPlus, faShieldBlank, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Card, CardContent, Container, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { HelvNeue } from 'themes/theme';
import { AccountTree } from '@material-ui/icons';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      paddingTop: theme.spacing(0),
      [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(5),
      },
    },
    inline: {
      display: 'flex',
      alignItems: 'center'
    }

  }
})

const Infocard = ({ }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>

      <Card>
        <CardContent>
          <List className={classes.list}>
            {['', '', ''].map((v, key) => {
              return (
                <React.Fragment key={key}>
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                    </ListItemAvatar>
                    <ListItemText
                      primary="TITLE"
                      secondary={
                        <Grid container>
                          <Grid item xs={12} sm={4}>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              STUB COL1
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {"STUB COL CONTENT"}
                            </Typography>
                          </Grid>
                        </Grid>
                      }
                    />
                  </ListItem>
                  <Divider component="li" />
                </React.Fragment>
              )
            })}



          </List>
        </CardContent>
      </Card>

    </div>
  )
}

export { Infocard };
